import { defineComponent as _defineComponent } from 'vue'
import ProductBenefitsItem from '~/components/sections/productSection/ProductBenefitsItem.vue';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductBenefits',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {



return { __sfc: true,ProductBenefitsItem }
}

})